import { Icon } from "@dgs/core";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Strong = styled.strong`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;
export const ErrorIcon = styled(Icon)`
	width: 1rem;
	height: 1rem;
	color: ${({ theme }) => theme.forms.error};
`;
export const ErrorText = styled.div`
	${({ theme }) => theme.forms.error};
`;
const FlexContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: ${({ theme }) => theme.spacing(2)};
`;

interface ValueProps {
	value?: ReactNode | null;
	className?: string;
	error?: string;
}

export const Value: FC<ValueProps> = ({ value, className, error }) => {
	const { t } = useTranslation();

	return (
		<span>
			<FlexContainer>
				{error && <ErrorIcon $icon="warning" />}
				<Strong className={className}>{value ? value : "-"}</Strong>
			</FlexContainer>
			{error && <ErrorText>{t(error)}</ErrorText>}
		</span>
	);
};
